import axios from "axios";
import { environment } from "../../../environment";
import { isAssetValueValid } from "../utils/isAssetValueValid";
export const url = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/dashboard/client/${clientId}/alts`
    : `https://middleware.uat.farther.com/dashboard/client/${clientId}/alts`;
export default async function postClientAlternativeAssets(clientId, assetType, assetName, assetValue, config) {
    const isValidValue = isAssetValueValid(assetValue);
    if (isValidValue !== true) {
        throw new Error(isValidValue);
    }
    await axios.post(url(clientId), {
        assetType: assetType,
        assetName: assetName,
        assetValue: assetValue.toString(),
        documentName: null,
    }, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
}
//# sourceMappingURL=postClientAlternativeAssets.js.map